export const TXTWCL_Please_enter_valid_Personal_Nu_ELL = {
  "id": "TXTWCL_Please_enter_valid_Personal_Nu_ELL",
  "defaultMessage": "Please enter valid Personal Number of Foreigner"
} as const;

export const TXTWCL_Please_enter_valid_Uniform_Civ_ELL = {
  "id": "TXTWCL_Please_enter_valid_Uniform_Civ_ELL",
  "defaultMessage": "Please enter valid Uniform Civil Number"
} as const;